import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Collapse } from '@mui/material';

import useActiveLink from '../../../hooks/useActiveLink';
import { NavListProps } from '../types';

import NavItem from './NavItem';

// ----------------------------------------------------------------------

type NavListRootProps = {
  data: NavListProps;
  depth: number;
  hasChild: boolean;
  index?: number;
};

export default function NavList({ data, depth, hasChild, index }: NavListRootProps) {
  const { pathname, search, hash } = useLocation();
  // children이 있을 경우에는 deep 인자값을 true로 설정하여 하위 path가 활성화되도록 설정
  const { active, isExternalLink } = useActiveLink(data.path, hasChild ? true : false);
  const fullPath = `${pathname}${search}${hash}`;
  const hasActivePaths = data.activePaths
    ? data.activePaths.some((path) => path === fullPath)
    : false;
  const isMenuPsidMenu = data.children.length > 0 ? true : false;
  const [open, setOpen] = useState(data.opened || active);

  const handleToggle = () => {
    setOpen(!open);
  };

  return (
    <>
      <NavItem
        item={data}
        depth={depth}
        open={open}
        active={hasActivePaths}
        isExternalLink={isExternalLink}
        onClick={handleToggle}
        sx={{
          ...(isMenuPsidMenu &&
            index !== 0 && {
              marginTop: 2,
              paddingTop: 3,
              paddingBottom: 2,
              borderTop: '1px solid rgba(145, 158, 171, 0.24)',
            }),
        }}
      />
      {hasChild && (
        <Collapse in={open} unmountOnExit>
          <NavSubList data={data.children} depth={depth} />
        </Collapse>
      )}
    </>
  );
}

// ----------------------------------------------------------------------

type NavListSubProps = {
  data: NavListProps[];
  depth: number;
};

function NavSubList({ data, depth }: NavListSubProps) {
  return (
    <>
      {data.map((list) => (
        <NavList
          key={list.title + list.path}
          data={list}
          depth={depth + 1}
          hasChild={!!list.children}
        />
      ))}
    </>
  );
}
